var heading_default = {
  "fontElementMap": "_4IfCf",
  "elementSpacing": "cdSI7",
  "headerOne": "aSk-7 cdSI7",
  "headerTwo": "_9SqOG cdSI7",
  "headerThree": "r5uVO cdSI7",
  "headerFour": "Vbjd8 cdSI7",
  "headerFive": "_13R4P cdSI7",
  "headerSix": "dy0je cdSI7",
  "child": "t8Qlu"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
